import { jsxs as n, jsx as s } from "react/jsx-runtime";
import { c as o } from "./index-Cu0xwYjD.js";
import './assets/CurrencyTextIcon.css';const c = "_wrapper_8j3bc_4", r = "_icon_8j3bc_10", i = "_left_8j3bc_14", l = "_right_8j3bc_18", a = "_input_8j3bc_41", h = "_hasLeftSlot_8j3bc_75", _ = "_hasRightSlot_8j3bc_79", e = {
  wrapper: c,
  icon: r,
  left: i,
  right: l,
  input: a,
  hasLeftSlot: h,
  hasRightSlot: _
}, p = {
  "£": "pound",
  $: "dollar",
  "€": "euro"
}, f = (t) => /* @__PURE__ */ n(
  "svg",
  {
    width: "16",
    height: "16",
    xmlns: "http://www.w3.org/2000/svg",
    pointerEvents: "none",
    "data-testid": `element-icon-${p[t]}`,
    className: o(e.icon, e.left),
    children: [
      /* @__PURE__ */ s("rect", { x: "0", y: "0", width: "16", height: "16", fill: "transparent" }),
      /* @__PURE__ */ s(
        "text",
        {
          x: "50%",
          y: "60%",
          dominantBaseline: "middle",
          textAnchor: "middle",
          fill: "currentColor",
          children: t
        }
      )
    ]
  }
);
export {
  f as C,
  e as s
};
